'use strict';

const _ = require('underscore');
const Backbone = require('backbone');
const Mn = require('backbone.marionette');
const i18n = require('i18next');
const Tooltip = require('common/ui/view/behavior/tooltip');
const Clipboard = require('common/util/clipboard');
const Snackbar = require('common/util/snackbar');
const PopoverView = require('common/ui/view/popover');
const UserMention = require('common/util/user-mention');
const ModalView = require('common/ui/view/modal/index');
const GroupMemberNameView = require('common/ui/view/group/member-name');
const TaskModel = require('communication/domain/entity/task');
const TaskCreateService = require('communication/app/service/task/create');
const TaskSettingView = require('communication/ui/view/task/setting');
const ReactionSelectorView = require('communication/ui/comment/view/reaction-selector');
const TaskCollectionRepository = require('communication/domain/repository/task-collection');
const ElementMention = require('system/util/element-mention');
const Template = require('communication/ui/comment/template/item.hbs');
const ItemTaskTemplate = require('communication/ui/comment/template/item-task.hbs');
const ShowMoreReplyTemplate = require('communication/ui/comment/template/show-more-reply.hbs');
const MentionTemplate = require('communication/ui/comment/template/mention.hbs');
const ReactionContainerView = require('communication/ui/comment/view/reaction');

const MentionItemView = Mn.View.extend({
    tagName: 'span',
    className: 'comment-mention-item',
    template: MentionTemplate,
    regions: {
        name: '.name'
    },
    templateContext() {
        const user = this.getOption('context').getUser();

        return {
            isMyMention: user.id == this.model.id
        }
    },
    onRender: function() {
        this.showChildView('name', new GroupMemberNameView({
            model: this.model
        }));
    },
});

const MentionListView = Mn.CollectionView.extend({
    childView: MentionItemView,
    childViewOptions: function() {
        return {
            context: this.getOption('context')
        }
    }
});

const TaskView = Mn.View.extend({
    template: ItemTaskTemplate,
    regions: {
        taskList: '.comment-task-list'
    },
    initialize: function() {
        this.listenTo(this.collection, 'add', this.toggle);
        this.toggle();
    },

    onRender: function() {
        const TaskListView = this.getOption('TaskListView');
        const CommentTaskListView = TaskListView.extend({
            inCommentTask: true,
            AdditionalView: this.getOption('AdditionalView'),

            // tasks をすべて表示するとタスクの返信コメントに同じタスクが表示されてしまうため、
            // そのコメントから作成されたタスクに限定して表示する。
            filter: function(child, index) {
                const comment = this.getOption('comment');
                const commentKey = child.getCommentKey();

                return comment.id == commentKey.id &&
                    CommentTaskListView.__super__.filter.call(this, child, index);
            }
        });

        this.showChildView('taskList', new CommentTaskListView({
            collection: this.collection,
            context: this.getOption('context'),
            comment: this.getOption('comment')
        }));
    },

    toggle: function() {
        if(this.collection.length > 0) {
            this.$el.show();
        } else {
            this.$el.hide();
        }
    }
});

const CommentItem = Mn.View.extend({
    inTaskComment: false,
    tagName: 'li',
    className: 'comment-list-item list-item',
    template: Template,
    modelEvents: {
        'change': 'render',
        'active': 'activate',
        'inactive': 'deactivate',
    },
    regions: {
        reactionSelector: '.reaction-selector-container',
        task: '.comment-task',
        additional: '.additional-view',
        mentionList: '.mention-list',
        primaryContext: '.primary-context',
        reactions: '.reactions'
    },
    triggers: {
        'click > .list-item-content .comment-reply-button': 'reply:child:comment'
    },
    events: {
        'click > .list-item-content .copy-comment-link': 'copyCommentLinks',
        'click > .list-item-content .add-reaction': 'showReactionSelector',
        'click > .list-item-content .task-create-button': 'createTask'
    },
    childViewEvents: {
        'add:thumbs:up:reaction': 'addThumbsUpReaction'
    },
    childViewTriggers: {
        'comment:add': 'comment:add',
        'comment:reaction:add': 'comment:reaction:add',
        'comment:additional:add': 'comment:additional:add',
    },
    behaviors: [Tooltip],

    templateContext: function() {
        const context = this.getOption('context');
        const user = context.getUser();
        const group = context.getGroup();
        const inTaskComment = this.getOption('inTaskComment');
        return {
            body: this.getOption('marked')(this.model.getBody()),
            isMember: group.isMember(user ? user.id : null),
            inTaskComment: inTaskComment,
            link: this.getLink()
        }
    },

    onRender: function() {
        const context = this.getOption('context');
        const group = context.getGroup();
        const project = context.getProject();

        this.$('.list-item-body').magnificPopup({
            delegate: 'p:parent img',
            type: 'image',
            gallery: {enabled: true},
            callbacks: {
                elementParse: function (item) {
                    item.src = item.el.attr('src');
                }
            }
        });

        this.$('.list-item-body').externalLinkTargetBlank();
        (new UserMention()).addClickHandler(this.$el);
        if(this.getOption('context') && this.getOption('channel')) {
            (new ElementMention(this.getOption('context'), this.getOption('channel'))).addClickHandler(this.$el);
        }

        const AdditionalView = this.getOption('AdditionalView');
        if(AdditionalView) {
            this.showChildView('additional', new AdditionalView({
                model: this.model,
                context: this.getOption('context'),
                hidePrimaryRelatedKey: true,
                commentLoader: this.getOption('commentLoader'),
            }));
        }

        const inTaskComment = this.getOption('inTaskComment');
        if(!inTaskComment) {
            TaskCollectionRepository.find(project)
                .byComment(this.model)
                .fetchTasksByIDs()
                .then(tasks => {
                    this.showChildView('task', new TaskView({
                        collection: tasks,
                        comment: this.model,
                        context: this.getOption('context'),
                        TaskListView: this.getOption('TaskListView'),
                        AdditionalView: this.getOption('AdditionalView')
                    }));
                });
        }

        this.showChildView('mentionList', new MentionListView({
            collection: new Backbone.Collection(
                _.map(this.model.getMentionTo(), uid => {
                    return group.getMembers({withSuspended: true}).getMemberByUser(uid);
                })
            ),
            context: this.getOption('context')
        }));

        const PrimaryContextView = this.getOption('PrimaryContextView');
        if(PrimaryContextView) {
            this.showChildView('primaryContext', new PrimaryContextView({
                model: this.model,
                context: this.getOption('context')
            }));
        }

        this.showChildView('reactions', new ReactionContainerView({
            model: this.model,
            context: this.getOption('context')
        }));

        // if(this.model.isActive()) {
        //     this.$el.addClass('is-active');
        // } else {
        //     this.$el.removeClass('is-active');
        // }
    },

    activate: function() {
        this.$el.addClass('is-active');
    },

    deactivate: function() {
        this.$el.removeClass('is-active');
    },

    // 本来、他のサブシステムのことを知っているべきではないが、実装速度を優先させるため一旦ここに置く
    getLink: function() {
        const context = this.getOption('context');
        const project = context.getProject();
        const key = this.model.getPrimaryRelatedKey();
        let path = `/projects/${project.id}`;

        if(key.kind == 'Action' && key.id == project.getActionID()) {
        } else if (key.kind == 'Action') {
            path += `/processes/${key.id}`;
        } else if (key.kind == 'DataContentVersion') {
            path += `/data-contents/${key.id}`;
        } else if (key.kind == 'Diagram') {
            path += `/diagrams/${key.id}`;
        }

        return path + `#/comments/${this.model.id}`;
    },

    copyCommentLinks: function() {
        const loc = window.location;
        const commentURL = `${loc.origin}${loc.pathname}#/comments/${this.model.id}`;
        Clipboard.setText({
            text: commentURL,
            onSet: () => {
                Snackbar.info("コピーしました");
            },
        });
        Clipboard.execCopy();
    },

    showReactionSelector: function() {
        const mappings = this.getChildView('reactions').getMappings();
        const reactionSelectorView = new ReactionSelectorView({
            mappings: mappings
        });

        const popoverView = new PopoverView({
            view: reactionSelectorView,
            show: true,
            placement: 'top',
            childViewTriggers: {
                'add:thumbs:up:reaction': 'add:thumbs:up:reaction'
            }
        });
        this.showChildView('reactionSelector', popoverView);
        this.listenTo(popoverView, 'hide', this.hideReactionSelector);
    },

    hideReactionSelector: function() {
        this.getRegion('reactionSelector').empty();
    },

    addThumbsUpReaction: function() {
        this.getChildView('reactions').addThumbsUpReaction();
        this.hideReactionSelector();
    },

    createTask: function() {
        const context = this.getOption('context');
        const user = context.getUser();
        const project = context.getProject();
        const comment = this.model;
        let relatedKeys = this.model.getRelatedKeys();
        if(this.getOption('replyTo')) {
            relatedKeys = relatedKeys.union(this.getOption('replyTo').getRelatedKeys());
        }
        let assignees = _.chain(this.model.getMentionTo())
            .map(uid => {
                return project
                    .getMembers()
                    .getMemberByUser(uid);
            })
            .filter(m => m != null)
            .map(m => m.getUser())
            .value();
        assignees.push(user);

        const modal = new ModalView({
            title: i18n.t('communication_template:modal.task.create-title'),
            bodyView: new TaskSettingView({
                model: new TaskModel(),
                assignees: assignees,
                CommentView: CommentItem,
                context: this.getOption('context'),
                comment: this.model,
                relatedKeys: relatedKeys,
                marked: this.getOption('marked'),
                AdditionalView: this.getOption('AdditionalView'),
            }),
            onChildviewSave: function() {
                const isValid = this.getChildView('body').model.isValid(true);
                if(!isValid) {
                    return;
                }

                this.disableButtons();
                let json = this.getChildView('body').getJSON();
                //TODO: ID は被るので Key にすること！
                json.comment = comment.key.toString();

                const taskService = new TaskCreateService(project, json);
                taskService.create()
                    .then(() => {
                        this.hide();
                    });
            }
        });
        modal.show();
    }
});

const ReplyCommentList = Mn.CollectionView.extend({
    tagName: 'ul',
    className: 'list list-sub',
    childView: CommentItem,
    childViewTriggers: {
        'comment:add': 'comment:add',
        'comment:reaction:add': 'comment:reaction:add',
        'comment:additional:add': 'comment:additional:add',
        'reply:child:comment': 'reply:child:comment',
        'active': 'active'
    },
    childViewOptions: function() {
        return {
            marked: this.getOption('marked'),
            replyTo: this.getOption('replyTo'),
            context: this.getOption('context'),
            channel: this.getOption('channel'),
            TaskListView: this.getOption('TaskListView'),
            AdditionalView: this.getOption('AdditionalView'),
            PrimaryContextView: this.getOption('PrimaryContextView')
        };
    },
    leastReplyNumToShow: 2,

    initialize: function() {
        this.setAbbreviatedCondition();
    },

    onRender: function() {
        if(this._showMoreReply) {
            this._showMoreReply.remove();
        }

        if(this.isAbbreviateReplyComments()) {
            // 最後の this.leastReplyNumToShow 個の返信をのぞいて省略する
            const abbreviatedReplyNum = (this.collection.length - this.leastReplyNumToShow);
            this._showMoreReply = $(ShowMoreReplyTemplate({replyNum: abbreviatedReplyNum}));

            this.getOption('replyTo').abbreviateReplyComments();

            this._showMoreReply.on('click', () => {
                this.getOption('replyTo').showReplyComments();
                this.render();
            });
            this.getChildViewContainer().prepend(this._showMoreReply);
        }
    },

    onAddChild: function() {
        // レンダリングが終わるまで少し待ってからスクロールする
        _.delay(() => {
            this.triggerMethod('comment:add');
        }, 100);
    },

    filter: function(child, index, collection) {
        if(this.isAbbreviateReplyComments()) {
            // 最後の this.leastReplyNumToShow 個の返信をのぞいて省略する
            return index >= (collection.length - this.leastReplyNumToShow);
        }

        return true;
    },

    getChildViewContainer: function() {
        if(!this.childViewContainer) {
            return this.$el;
        }

        if(_.isFunction(this.childViewContainer)) {
            return this.$(this.childViewContainer());
        }

        return this.$(this.childViewContainer);
    },

    setAbbreviatedCondition: function() {
        this._abbreviated = this.collection.length > this.leastReplyNumToShow;
        if (this._abbreviated) {
            this.getOption('replyTo').abbreviateReplyComments();
        }
    },

    isAbbreviateReplyComments: function() {
        const showReplyComments = this.getOption('replyTo').isShowReplyComments();
        return !showReplyComments && this._abbreviated;
    },

    onChangeActivate: function(key, options = {}) {
        options = options || {};
        const showReplyComments = !options.notShowReplyComments;

        // このリスト内に対象コメントが存在する場合、最新 N個だけ省略表示する機能を無効化して、再描画する
        const hasTargetComment = this.children.find(childView => {
            return key && key.isEqual(childView.model.getKey());
        });
        if (hasTargetComment && showReplyComments) {
            this.getOption('replyTo').showReplyComments();
            this.render();
        }

        this.children.each(childView => {
            const model = childView.model;
            if (key && key.isEqual(model.getKey())) {
                childView.activate();
            } else {
                childView.deactivate();
            }
        });
    }
});

const RootComment = CommentItem.extend({
    showReply: true,
    childViewTriggers: {
        'comment:add': 'comment:add',
        'comment:reaction:add': 'comment:reaction:add',
        'comment:additional:add': 'comment:additional:add',
        'reply:child:comment': 'reply:comment',
        'active': 'active'
    },
    triggers: {
        'click > .list-item-content .comment-reply-button': 'reply:comment'
    },
    regions: {
        reactionSelector: '.reaction-selector-container',
        task: '.comment-task',
        additional: '.additional-view',
        mentionList: '.mention-list',
        reply: '.reply-comments',
        primaryContext: '.primary-context',
        reactions: '.reactions'
    },

    onRender: function() {
        RootComment.__super__.onRender.call(this);

        const showReply = this.getOption('showReply');
        if(showReply) {
            this.showChildView('reply', new ReplyCommentList({
                collection: this.model.getReplyComments(),
                replyTo: this.model,
                marked: this.getOption('marked'),
                context: this.getOption('context'),
                channel: this.getOption('channel'),
                commentLoader: this.getOption('commentLoader'),
                TaskListView: this.getOption('TaskListView'),
                AdditionalView: this.getOption('AdditionalView'),
                PrimaryContextView: this.getOption('PrimaryContextView')
            }));
        }
    },

    onChangeActivate: function(key, options = {}) {
        if (key && key.isEqual(this.model.getKey())) {
            this.activate();
        } else {
            this.deactivate();
        }

        const replyView = this.getChildView('reply');
        if (replyView) {
            replyView.onChangeActivate(key, options);
        }
    }
});

module.exports = RootComment;



// WEBPACK FOOTER //
// ./communication/ui/comment/view/item.js